import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import rtspUrlReducer from "./slices/streamUrlSlice";
import filesReducer from "./slices/filesSlice";
import zoomReducer from "./slices/useZoomStore.js";
import userReducer from "./slices/userSlice";

/**
 * Redux store configuration with auth slice
 */
export const store = configureStore({
  reducer: {
    auth: authReducer,
    rtspUrl: rtspUrlReducer,
    files: filesReducer,
    zoom: zoomReducer,
    user: userReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});

// Verify store initialization in development
if (process.env.NODE_ENV === "development") {
  console.log("[Redux Store] Initialized with reducers:", {
    auth: !!authReducer,
    rtspUrl: !!rtspUrlReducer,
    files: !!filesReducer,
    zoom: !!zoomReducer,
    user: !!userReducer,
  });
  console.log("[Redux Store] Initial zoom state:", store.getState().zoom);
  console.log("[Redux Store] Initial user state:", store.getState().user);
}
